import script from "./CalendarMonth.vue?vue&type=script&setup=true&lang=ts"
export * from "./CalendarMonth.vue?vue&type=script&setup=true&lang=ts"

import "./CalendarMonth.vue?vue&type=style&index=0&id=207c6ca6&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-207c6ca6"]])

export default __exports__